import { motion } from "framer-motion";
import { MapPin, Mountain, Plane, TrainFront, UtensilsCrossed } from "lucide-react";
import ChapterHeading from "@/components/landing/ChapterHeading";

const GROUPS = [
  {
    icon: UtensilsCrossed,
    title: "Ristoranti e caffetterie",
    items: [
      ["Locanda dei Sapori", "250 m"],
      ["La Macchia", "2,4 km"],
      ["Bar La Chiocciola", "2,8 km"],
    ],
  },
  {
    icon: Mountain,
    title: "Bellezze della natura",
    items: [
      ["Forca di Cerro", "4 km"],
      ["Monteluco di Spoleto", "10 km"],
      ["Cascata delle Marmore", "33 km"],
      ["Lago di Piediluco", "41 km"],
    ],
  },
  {
    icon: TrainFront,
    title: "Mezzi e collegamenti",
    items: [
      ["Stazione di Spoleto", "4,1 km"],
      ["Teatro Clitunno", "17 km"],
      ["Abbazia San Pietro in Valle", "21 km"],
    ],
  },
  {
    icon: Plane,
    title: "Aeroporto",
    items: [["Perugia San Francesco d'Assisi", "51 km"]],
  },
];

export default function Dintorni() {
  return (
    <section id="dintorni" data-testid="dintorni-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
      <ChapterHeading
        eyebrow="Capitolo 04"
        title="Dintorni & Posizione"
        subtitle="Nel cuore verde dell'Umbria: il borgo di Eggi è il punto di partenza perfetto tra Spoleto, la Valnerina e i borghi più belli d'Italia."
      />

      <div className="grid gap-10 lg:grid-cols-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="overflow-hidden rounded-sm border border-stone-300/50 shadow-xl shadow-stone-900/10 lg:col-span-7"
        >
          <iframe
            data-testid="google-map-embed"
            title="Mappa di Saint Anthony, Eggi di Spoleto"
            src="https://maps.google.com/maps?q=Via%20Giovanni%20Crivellini%2026%2C%2006049%20Spoleto%20PG&t=&z=13&ie=UTF8&iwloc=&output=embed"
            className="h-[420px] w-full border-0"
            loading="lazy"
          />
          <a
            data-testid="map-directions-link"
            href="https://maps.app.goo.gl/hTBFZF9JKr9CskCN9"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-stone-900 px-6 py-4 text-sm text-linen transition-colors hover:bg-stone-800"
          >
            <MapPin size={16} className="text-oro" />
            Via Giovanni Crivellini, 26 — 06049 Eggi, Spoleto (PG)
            <span className="ml-auto text-xs uppercase tracking-[0.15em] text-oro">Indicazioni</span>
          </a>
        </motion.div>

        <div className="grid content-start gap-6 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
          {GROUPS.map((g, gi) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: gi * 0.08 }}
              className="rounded-sm border border-stone-300/50 bg-white p-6"
            >
              <div className="mb-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
                  <g.icon size={16} />
                </span>
                <h3 className="font-serif text-lg text-stone-800">{g.title}</h3>
              </div>
              <ul className="space-y-2">
                {g.items.map(([name, dist]) => (
                  <li key={name} className="flex items-baseline justify-between gap-4 text-sm">
                    <span className="font-light text-stone-600">{name}</span>
                    <span className="shrink-0 font-mono text-xs text-terracotta">{dist}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
